import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Gallery } from 'src/app/shared/utils/gallery';

@Injectable({
    providedIn: 'root'
})

export class ViewService{

    private callback = new BehaviorSubject<any>([]);
    callback$ = this.callback.asObservable();

    constructor(
        protected ga: Gallery
    ){
    }

    setCallback(data){
        this.callback.next(data);
    }

    setGallery(dataItem, galleryList = 'imagesAndVideos') {
        this.ga.setGallery(dataItem, galleryList);
    }

}